(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'TravelVault',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		$('.travel-vault-options').click(function toggleButtons() {
			var type = $(this).data("type");

			if (type === 'note') {
				$('#travelvault-type').val('note');

				$('.note-form').removeClass('hidden');
				$('.file-form').addClass('hidden');

				$('#travelvault-note_id').val('');
				$('#travelvault-note_title').val('');
				$('#travelvault-description').val('');
			} else {
				$('#travelvault-type').val('file');

				$('.note-form').addClass('hidden');
				$('.file-form').removeClass('hidden');
			}
		});

		$('.cancel-form').click(function hideForm(e) {
			e.preventDefault();

			$('.file-form').addClass('hidden');
			$('.note-form').addClass('hidden');

			$('#travelvault-note_id').val('');
			$('#travelvault-note_title').val('');
			$('#travelvault-description').val('');
		});
	};

}(jQuery, window.Adzuki || {}));
